// extracted by mini-css-extract-plugin
module.exports = {"title":"WidgetHeader_title__2-UEO","reward-title":"WidgetHeader_reward-title__21Ctt"};